export enum UserMiVBEmailEvents {
    INPROGRESS = 'inProgress',
	SUCCEEDED = 'succeeded',
	FAILED = 'failed',
};